import { render, staticRenderFns } from "./get-started.vue?vue&type=template&id=43a9d72c"
import script from "./get-started.vue?vue&type=script&lang=js"
export * from "./get-started.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports